@if ((cartItems$ | async)?.length) {
  <div class="cart-companion">
    @for (cartItem of cartItems$ | async; track cartItem.id) {
      <app-cart-item [item]="cartItem" [companionMode]="true"></app-cart-item>
    }
  </div>
} @else {
  <em>You have no addons in your shopping cart</em>
}
